export const FORGOT_PASSWORD = 'APP/FORGOT_PASSWORD'
export const FORGOT_PASSWORD_SUCCESS = 'APP/FORGOT_PASSWORD_SUCCESS'
export const FORGOT_PASSWORD_ERROR = 'APP/FORGOT_PASSWORD_ERROR'
export const FORGOT_PASSWORD_CLEAN_UP = 'APP/FORGOT_PASSWORD/CLEAN_UP'
